import React, { PropsWithChildren, ReactNode } from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useModePanelStyle, CompPanelHeader, BaseCompProps } from '@moderepo/mode-app-components';



const useStyle = makeStyles(() => {

    return {
        root: {
            overflow : 'hidden',
            height   : 500,
            minHeight: 'unset',
        },

        panelContent: {
            padding      : 0,
            height       : '100%',
            display      : 'flex',
            flexDirection: 'column',
        },
    };
}, {
    name: 'WidgetGroupViewCompProps', index: 1,
});



export interface WidgetGroupWidgetViewCompProps extends BaseCompProps {
    readonly showBackground?: boolean | undefined;
}



/**
 * This is the UI/Data View for the ValueDashboardWidget. This component will display the time series values as 1 SINGLE VALUE.
 */
export const WidgetGroupWidgetViewComp: React.FC<WidgetGroupWidgetViewCompProps> = (
    props: WidgetGroupWidgetViewCompProps & PropsWithChildren<ReactNode>,
) => {
    const panelClasses = useModePanelStyle();
    const classes = useStyle();

    return (
        <Paper
            elevation={2}
            className={clsx(panelClasses.root, classes.root, props.className, !props.showBackground && 'transparent',
                props.showCustomActionOnHover && 'show-custom-action-on-hover')}
        >
            <CompPanelHeader {...props} />
            <div className={clsx(panelClasses.panelContent, classes.panelContent)}>
                {props.children}
            </div>
        </Paper>
    );
};
